// extracted by mini-css-extract-plugin
module.exports = {"title":"AppBar_title__1UGFm","padRight":"AppBar_padRight__IpEUG"};